import { Controller } from '@hotwired/stimulus'

// A task can point into a booking card loaded by Turbo. Focus once the actual row exists,
// rather than relying on a URL fragment that is absent during the initial navigation.
export default class WorkflowFocusController extends Controller<HTMLElement> {
  static override values = { id: String }
  declare readonly idValue: string
  private focused = false
  private frame?: number

  override connect(): void {
    this.frame = requestAnimationFrame(() => this.reveal())
  }

  override disconnect(): void {
    if (this.frame !== undefined) cancelAnimationFrame(this.frame)
  }

  reveal(): void {
    if (this.focused || !this.idValue) return
    const row = document.getElementById(this.idValue)
    if (!row || !this.element.contains(row)) return
    this.focused = true
    row.tabIndex = -1
    row.setAttribute('data-workflow-focused', '')
    row.classList.add('outline', 'outline-2', 'outline-primary', 'outline-offset-2', 'rounded')
    row.focus({ preventScroll: true })
    row.scrollIntoView({ block: 'center', behavior: 'instant' })
  }
}
